import type { AnchorHTMLAttributes, ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { AlignItemsProps, DisplayProps } from 'styled-system';
import { alignItems, display } from 'styled-system';

import Icon from 'common/components/Icon';
import { LinkWithIcon } from 'common/components/Link';
import { LinkRegularLR1 } from 'common/components/Typography';
import { useLocalization } from 'common/providers/LocaleProvider';
import { textDecoration } from 'common/theme/system-utilities';

export type SeeAllLink = AnchorHTMLAttributes<HTMLAnchorElement> & {
  url: string;
  text: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement | HTMLDivElement>) => void;
};

const StyledLink = styled(LinkWithIcon)<DisplayProps & AlignItemsProps>`
  white-space: nowrap;
  ${display};
  ${alignItems};
  ${textDecoration}
`;

const styledLinkStyles: ComponentProps<typeof StyledLink> = {
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'underline',
  color: 'sys.neutral.text.default',
};

const arrowStyles: ComponentProps<typeof Icon> = {
  size: 24,
  fill: 'sys.neutral.text.strong',
  name: 'arrowRight',
};

const ShowAllLink = ({ text, url, onClick }: SeeAllLink) => {
  const { t } = useLocalization();

  return (
    <StyledLink href={url} onClick={onClick} {...styledLinkStyles}>
      <LinkRegularLR1 aria-label={t('h24_show_all_label')} as="span" color="inherit">
        {text}
      </LinkRegularLR1>
      <Icon {...arrowStyles} />
    </StyledLink>
  );
};

export default ShowAllLink;
